<template>
	<div class="deviceBuyout__col col-12">
		<div id="buyout_appraisalForm" class="deviceBuyout__title deviceBuyout__col col-12">
			<slot name="title">
				<template v-if="isBuyoutOnline || isOnlyOnlineBuyout">
					<span class="step">1/{{ getTotalSteps }}</span>
				</template>
				{{ $t('buyout.detail_pricing') }}
			</slot>
		</div>

		<div class="deviceBuyout__detail">
			<slot name="dynamicInputType"
						:acceptableDeviceConditions="acceptableDeviceConditions"
						:qualityDeviceConditions="qualityDeviceConditions"
						:update="update"
			>
			<dynamic-input
				v-for="(input, index) in acceptableDeviceConditions"
				:ref="`input-${input.id}`"
				:key="input.id"
				:input="input"
				:disabled="disabled"
				:index="index + qualityDeviceConditions.length"
				@input="update($event, index + qualityDeviceConditions.length)"
			/>
			</slot>
			<div
				class="row"
				v-for="(error, index) in _.get(
					appraisalErrors,
					'device_condition_choices'
				)"
				:key="index"
			>
				<div class="col">{{ error }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import DynamicInput from './DynamicInput';
import get from 'lodash/get';
import { config } from '../../../config/buyout';
import {VUEX_BUYOUT} from '../../../../vue/store/buyout/index';
import {mapState, mapActions, mapGetters} from 'vuex';
import { ACTION_TYPES } from '../../../store/buyout/_action-types';
import { GETTER_TYPES } from '../../../store/buyout/_getter-types';

export default {
	name: 'AppraisalForm',
	data() {
		return {
			allowed_types: ['boolean', 'list'],
			localSelectedQuality: null,
		}
	},
	computed: {
		...mapState(VUEX_BUYOUT.NAMESPACE,[
			'userBuyoutCode',
			'isAppraisalEditable',
			'isBuyoutOnline',
			'appraisal',
			'appraisalErrors',
			'selectedQuality',
			'appraisalResults',
		]),
		...mapGetters(VUEX_BUYOUT.NAMESPACE, [
			GETTER_TYPES.GET_BUYOUT_APPRAISAL_RESULT_BY_ID,
			GETTER_TYPES.TOTAL_STEPS,
		]),
		getTotalSteps: {
			get() {
				return this[GETTER_TYPES.TOTAL_STEPS];
			},
		},
		acceptableDeviceConditions() {
			return (this.appraisal?.device_conditions || []).filter(item =>
				this.allowed_types.includes(item.type)
			);
		},
		qualityDeviceConditions() {
			return (this.appraisal?.device_conditions || []).filter(item =>
				item.type === "quality"
			).map(item => {
        let choice = item?.choices[0]
        let res = choice?.appraisal_result;
        if(!res) return null;
        let appraisal_result = this[GETTER_TYPES.GET_BUYOUT_APPRAISAL_RESULT_BY_ID][res];
        return (appraisal_result && this.localSelectedQuality && appraisal_result.quality === this.localSelectedQuality.quality) ? choice : null;
      });
		},
		availableQualities() {
			return (this.appraisal?.device_conditions || []).filter(item =>
				item.type === "quality"
			).map(item => {
        let choice = item?.choices[0]
        return choice?.appraisal_result;
      }).filter(item => !!item);
		},
		_() {
			return {
				get
			}
		},
		isOnlyOnlineBuyout: () => config.isOnlyOnlineBuyout,
		disabled() {
			return !this.isAppraisalEditable || Boolean(this.userBuyoutCode);
		}
	},
	created() {
		this.updateQualityChoices();
		if(this.selectedQuality) {
			this.localSelectedQuality = this.selectedQuality;
		}
	},
	methods: {
		...mapActions(VUEX_BUYOUT.NAMESPACE, [
			ACTION_TYPES.SET_APPRAISAL_RESULT,
			ACTION_TYPES.DETERMINE_SELECTED_QUALITY,
		]),
		update(value, index) {
      const dc_choice_results = this.appraisal.device_conditions[index].choices.map(item => item.appraisal_result);
      const can_reset_quality = !(
				dc_choice_results.every((v) => v === dc_choice_results[0])
				&& this.availableQualities.some(q => q === dc_choice_results[0])
			);
			const is_appraisal_filled = (
				(this.appraisalResults.slice(this.qualityDeviceConditions.length).filter(item => item).length === this.acceptableDeviceConditions.length)
			)

      if(can_reset_quality && is_appraisal_filled) this.localSelectedQuality = null;

			this[ACTION_TYPES.SET_APPRAISAL_RESULT]({ value, index });
			this.$nextTick(() => {
				this[ACTION_TYPES.DETERMINE_SELECTED_QUALITY]();
			});
		},
    updateQualityChoices() {
      this.qualityDeviceConditions.map((q, i) => this[ACTION_TYPES.SET_APPRAISAL_RESULT]({value: q, index: i}));
    }
	},
  watch: {
    qualityDeviceConditions() {
			this.updateQualityChoices();
			this[ACTION_TYPES.DETERMINE_SELECTED_QUALITY]();
		},
    selectedQuality() {
      this.localSelectedQuality = this.selectedQuality;
    },
  },
	components: {
		DynamicInput
	}
}
</script>
